import React, { useState } from "react";
import {
    AreaChart,
    Area,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from "recharts";

const AppointmentDetails = ({ appointmentData }) => {

    const [activeWeek, setActiveWeek] = useState(appointmentData[0]?.date || "Week 1");
    appointmentData = [...appointmentData].reverse();

    // Get selected week's total
    const weekData = appointmentData.find((w) => w.date === activeWeek) || {};
    const totalSelectedWeek = weekData.total || 0;

    return (
        <div className="bg-white rounded-xl shadow p-6 flex gap-6">
            {/* Left Summary Section */}
            <div className="w-[30%] space-y-4">
                <h3 className="text-md font-semibold text-[#003A71]">Summary</h3>

                <div className="p-3 rounded-lg border border-blue-400 bg-blue-50">
                    <div className="text-sm text-gray-600">{activeWeek}</div>
                    <div className="text-xl font-bold text-[#00C48E]">Appointments : {totalSelectedWeek}</div>
                </div>
            </div>

            {/* Right Chart Section */}
            <div className="w-[70%]">
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-md font-semibold text-[#003A71]">Appointment Details</h3>
                </div>

                {/* Week Tabs */}
                <div className="flex gap-2 mb-4">
                    {appointmentData.map((week) => (
                        <button
                            key={week.date}
                            className={`px-4 py-2 rounded-lg text-sm font-medium ${activeWeek === week.date
                                ? "bg-blue-500 text-white"
                                : "bg-gray-100 text-gray-700 hover:bg-blue-100"
                                }`}
                            onClick={() => setActiveWeek(week.date)}
                        >
                            {week.date}
                        </button>
                    ))}
                </div>

                <ResponsiveContainer width="100%" height={400}>
                    <AreaChart data={appointmentData} margin={{ top: 10, right: 20, left: 0, bottom: 5 }}>
                        <defs>
                            <linearGradient id="colorTotal" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="5%" stopColor="#00C48E" stopOpacity={0.6} />
                                <stop offset="95%" stopColor="#00C48E" stopOpacity={0} />
                            </linearGradient>
                        </defs>
                        <CartesianGrid vertical={false} stroke="#f0f0f0" />
                        <XAxis dataKey="date" axisLine={false} tickLine={false} />
                        <YAxis axisLine={false} tickLine={false} />
                        <Tooltip formatter={(v) => [v, "Appointments"]} />
                        <Area
                            type="monotone"
                            dataKey="total"
                            stroke="#00C48E"
                            fill="url(#colorTotal)"
                            dot={(props) => {
                                const { cx, cy, payload } = props;
                                const isActive = payload.date === activeWeek;
                                return (
                                    <circle
                                        cx={cx}
                                        cy={cy}
                                        r={isActive ? 6 : 3}
                                        fill={isActive ? "#003A71" : "#00C48E"}
                                        stroke={isActive ? "#003A71" : "#00C48E"}
                                    />
                                );
                            }}
                            activeDot={{ r: 6, fill: "#003A71", stroke: "#003A71" }}
                        />
                    </AreaChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default AppointmentDetails;
